<template>
  <!-- 季度选择时间控件 -->
  <div class="quarter-picker">
    <span>
      <mark class="el-mark" style="" v-show="showSeason" @click.stop="showSeason = false"></mark>
      <el-input :placeholder="placeholder" v-model="showValue" style="width: 150px" @focus="showSeason = true">
        <i slot="prefix" class="icon icon-calendar"></i>
        <!-- prefix-icon="icon icon-calendar" -->
      </el-input>
      <el-card class="box-card" style="" v-show="showSeason">
        <div slot="header" class="firstBtn">
          <button type="button" :aria-label="$t('components_seasonPicker.qian_yi_nian')" class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left" @click="prev"></button>
          <span role="button" class="el-date-picker__header-label">{{ year }}{{ $t('components_seasonPicker.nian') }}</span>
          <button type="button" :aria-label="$t('components_seasonPicker.hou_yi_nian')" @click="next" class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right"></button>
        </div>
        <div class="text container">
          <!-- 如下，绑定class,disabled为禁止选择的时间的设置 -->
          <el-button
            type="text"
            size="medium"
            :class="{ colorDis: isDisabled(1), colorActive: this.year === this.activeYear && this.season === 1 }"
            :disabled="isDisabled(1)"
            style="width: 47%; color: #606266; float: left"
            @click="selectSeason(0)"
          >
            {{ $t('components_seasonPicker.di_yi_ji_du') }}
          </el-button>
          <el-button
            type="text"
            size="medium"
            :class="{ colorDis: isDisabled(2), colorActive: this.year === this.activeYear && this.season === 2 }"
            :disabled="isDisabled(2)"
            style="float: right; width: 47%; color: #606266"
            @click="selectSeason(1)"
          >
            {{ $t('components_seasonPicker.di_er_ji_du') }}
          </el-button>
        </div>
        <div class="item container" style="text-align: center">
          <el-button
            type="text"
            size="medium"
            :class="{ colorDis: isDisabled(3), colorActive: this.year === this.activeYear && this.season === 3 }"
            :disabled="isDisabled(3)"
            style="width: 47%; color: #606266; float: left"
            @click="selectSeason(2)"
          >
            {{ $t('components_seasonPicker.di_san_ji_du') }}
          </el-button>
          <el-button
            type="text"
            size="medium"
            :class="{ colorDis: isDisabled(4), colorActive: this.year === this.activeYear && this.season === 4 }"
            :disabled="isDisabled(4)"
            style="float: right; width: 47%; color: #606266"
            @click="selectSeason(3)"
          >
            {{ $t('components_seasonPicker.di_si_ji_du') }}
          </el-button>
        </div>
      </el-card>
    </span>
  </div>
</template>
<script>
/**
 * @file:  View 组件 季节选择控件
 * @description: UI组件  可选择季节
 * @api: valueArr : 季度value defalut['01-03', '04-06', '07-09', '10-12'] 默认值待设置
 * 代码中注释部分是组件原默认时间配置，我这里做了更改，但是原设置可以参考
 */

export default {
  name: 'jududatepicker',
  props: {
    valueArr: {
      default: () => ['01', '02', '03', '04'],
      type: Array,
    },
    getValue: {
      default: (val) => val,
      type: Function,
    },
    value: {
      type: String,
      default() {
        return '';
      },
    },
    placeholder: {
      type: String,
      default() {
        return '';
      },
    },
    isInterval: {
      type: Boolean,
      default() {
        return false;
      },
    },
    max: {
      type: String,
      default() {
        return 'false';
      },
    },
    min: {
      type: String,
      default() {
        return 'false';
      },
    },
    // defaultValue: {
    //   // 默认值 201904-201906
    //   default: "",
    //   type: String
    // }
  },
  data() {
    return {
      showSeason: false,
      activeYear: '',
      season: '',
      year: new Date().getFullYear(), // input显示时间，会随着用户操作改变
      defaultyear: new Date().getFullYear(), // 当前年份，不变
      month: new Date().getMonth() + 1, // 当前月份，不变
      maxSeason: '',
      showValue: '',
      beforeyear: null, // 默认显示上一季度所用时间，可能是去年
    };
  },
  created() {
    // if (this.defaultValue) {
    //   let value = this.defaultValue;
    //   let arr = value.split("-");
    //   this.year = arr[0].slice(0, 4);
    //   let str = arr[0].slice(4, 6) + "-" + arr[1].slice(4, 6);
    //   let arrAll = this.valueArr;
    //   // valueArr ["01-03", "04-06", "07-09", "10-12"]
    //   this.showValue = `${this.year} 年 ${arrAll.indexOf(str) + 1} 季度`;
    // }
  },
  mounted() {
    this.initTime();
  },
  activated() {
    this.getDefaultTime();
  },
  watch: {
    value: function (val) {
      if (val) {
        const activeYear = this.value.split('-')[0];
        this.activeYear = +activeYear;
        const season = this.value.split('-')[1];
        this.season = +season;
        // init显示值
        this.showValue = this.$t('components_seasonPicker.onianoji_du', [this.activeYear,this.season]);
      } else {
        this.showValue = '';
      }
    },
  },
  methods: {
    one() {
      this.showSeason = false;
    },
    prev() {
      this.year = this.year * 1 - 1;
    },
    next() {
      this.year = this.year * 1 + 1;
    },
    selectSeason(i) {
      const that = this;
      that.season = i + 1;
      this.activeYear = that.year;
      const arr = that.valueArr[i];
      const seasonValue = that.getValue(`${that.year}-${arr}`);
      that.showSeason = false;
      this.showValue = this.$t('components_seasonPicker.onianoji_du', [this.year,this.season]);
      // 2020年3季度
      that.$emit('chooseSeason', seasonValue); // 每次选择时间都将当前选择时间发送到父组件
      this.$emit('input', seasonValue);
      // this.$emit('changeTime');
      // console.log(seasonValue);
      this.$emit('change', seasonValue);
    },
    reset() {
      // 季度重置 上一季度
      this.getDefaultTime();
    },
    initTime() {
      var month = this.month;
      if (month <= 3) {
        this.maxSeason = 1;
        this.season = 1;
      } else if (month > 3 && month <= 6) {
        this.maxSeason = 2;
        this.season = 2;
      } else if (month > 6 && month <= 9) {
        this.maxSeason = 3;
        this.season = 3;
      } else if (month > 9 && month <= 12) {
        this.maxSeason = 4;
        this.season = 4;
      }
      if (this.value) {
        const activeYear = this.value.split('-')[0];
        this.activeYear = +activeYear;
        const season = this.value.split('-')[1];
        this.season = +season;
        // init显示值
        this.showValue = this.$t('components_seasonPicker.onianoji_du', [this.activeYear,this.season]);
        this.year = this.activeYear;
      }
    },
    getDefaultTime() {
      // 获取默认的上一个季度
      var year = this.defaultyear;
      var month = this.month;
      var season = null;
      if (month <= 3) {
        this.maxSeason = 1;
        this.season = 1;
        year -= 1;
        season = 4;
        this.beforeyear = year;
      } else if (month > 3 && month <= 6) {
        this.maxSeason = 2;
        this.season = 2;
        season = 1;
        this.beforeyear = year;
      } else if (month > 6 && month <= 9) {
        this.maxSeason = 3;
        this.season = 3;
        season = 2;
        this.beforeyear = year;
      } else if (month > 9 && month <= 12) {
        this.maxSeason = 4;
        this.season = 4;
        season = 3;
        this.beforeyear = year;
      }
      this.showValue = this.$t('components_seasonPicker.onianoji_du', [year,season]);
    },
    // 判断按钮是否禁用，传入季节参数 (1, 2, 3, 4)
    isDisabled(season) {
      // 添加不能选择2016年之前的时间的限制
      const minYearLimit = 2016;
      if (this.year < minYearLimit) {
        return true;
      }
      // 选择范围不做限制
      if (!this.isInterval) {
        return (this.year === this.defaultyear && this.maxSeason + 1 <= season) || this.year > this.defaultyear;
      }

      const maxYear = this.max ? parseInt(this.max.split('-')[0], 10) : null;
      const maxQuarter = this.max ? parseInt(this.max.split('-')[1], 10) : null;
      const minYear = this.min ? parseInt(this.min.split('-')[0], 10) : null;
      const minQuarter = this.min ? parseInt(this.min.split('-')[1], 10) : null;

      const currentYear = new Date().getFullYear();
      const currentQuarter = Math.ceil((new Date().getMonth() + 1) / 3);

      // 判断是否是未来的季度
      const isFutureQuarter = this.year > currentYear || (this.year === currentYear && season > currentQuarter);

      // 1. 如果有 max (最大选择季度)
      if (maxYear && maxQuarter) {
        // 判断是否超过可选范围（最大3年）
        const isOutOfRange = this.year < maxYear - 3 || this.year > maxYear + 3 || (this.year === maxYear + 3 && season > maxQuarter);
        return isFutureQuarter || isOutOfRange;
      }

      // 2. 如果有 min (最小选择季度)
      if (minYear && minQuarter) {
        // 判断是否超过可选范围（最小3年）
        const isOutOfRange = this.year < minYear - 3 || this.year > minYear + 3 || (this.year === minYear + 3 && season > minQuarter);

        // 判断是否是未来的季度
        const isFutureQuarterMin = this.year > currentYear || (this.year === currentYear && season > currentQuarter);

        return isFutureQuarterMin || isOutOfRange;
      }

      // 默认禁用条件
      return isFutureQuarter;
    },
  },
};
</script>

<style lang="scss">
.quarter-picker {
  display: inline;
  position: relative;
  .firstBtn {
    height: 30px;
    line-height: 34px;
    width: 100%;
    text-align: center;
  }
  .el-input__inner {
    padding: 0 12px 0 32px;
    font-size: 14px;
  }
  .text {
    text-align: center;
    margin: 15px 0 10px;
  }
  .item {
    text-align: center;
  }
  .el-input__prefix {
    left: 10px;
    // line-height: 1;
    .icon-calendar {
      line-height: 32px;
      font-size: 14px;
      color: #0d9ae0;
    }
  }
}
.colorDis {
  color: #999 !important;
}
.colorActive {
  color: #0d9ae0 !important;
}
.quarter-picker {
  .el-card__header {
    padding: 12px;
  }

  .el-mark {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0);
    z-index: 999;
  }
  .box-card {
    width: 322px;
    padding: 0 3px 20px;
    margin-top: 10px;
    position: fixed;
    z-index: 9999;
  }
}
</style>
